import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useMicroMessageStore = defineStore('MicroMessageStore', () => {
  const microMessageMapping = ref<Record<string, any>>({});
  const getMessageData = (appName: string, key: string, defaultValue?: any) => {
    const messages = microMessageMapping.value[appName] || {};
    return messages[key] || defaultValue;
  };
  const setMessageData = (appName: string, key: string, value: any) => {
    const messages = microMessageMapping.value[appName] || {};
    messages[key] = value;
    microMessageMapping.value[appName] = messages;
  };
  const resetMessageData = (appName: string) => {
    microMessageMapping.value[appName] = {};
  };
  return {
    microMessageMapping,
    getMessageData,
    setMessageData,
    resetMessageData,
  };
});

export type IMicroMessageStoreStore = ReturnType<typeof useMicroMessageStore>;
